//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {Box, Stack, Typography} from '@mui/material';
import {currency_atom} from 'atoms';
import {get_price_str} from 'common';
import {useActiveOrders} from 'hooks/orderHooks';
import {useAuth, useBalance} from 'hooks/userHooks';
import {useRecoilValue} from 'recoil';

//---------------------------------------------------------
// Component
//---------------------------------------------------------
export function Header() {
	const {logout, user_info, is_logged_in} = useAuth();
	const currency = useRecoilValue(currency_atom);
	const {balance, isLoading} = useBalance();
	const {tvl} = useActiveOrders();

	const showAccount = is_logged_in && !isLoading;

	return (
		<Box id="header" zIndex={100} width="100%" px={1} display="flex" alignItems="center" justifyContent="space-between" bgcolor="background.default">
			<Stack>
				<Box onClick={logout} display="flex" alignItems="center" justifyContent="center" gap={1} sx={{cursor: 'pointer'}}>
					<Typography variant="body1">CCM</Typography>
				</Box>

				<Typography variant="caption">{user_info.username || 'Logged Out'}</Typography>
			</Stack>

			{showAccount && (
				<Stack>
					<Box id="tvl" width="100%" minWidth="180px" display="flex" alignItems="center" justifyContent="flex-end" gap="10px" flex={1}>
						<Typography variant="caption" color="text.disabled">
							Total Value
						</Typography>

						<Typography variant="caption">{get_price_str(balance + tvl, true, 0)}</Typography>
						<Typography variant="caption">{currency}</Typography>
					</Box>

					<Box id="available" width="100%" height="100%" display="flex" alignItems="center" justifyContent="flex-end" gap="10px">
						<Typography variant="caption">Available</Typography>
						<Typography variant="caption" color="primary.main">
							{get_price_str(balance, true, 0)}
						</Typography>
						<Typography variant="caption">{currency}</Typography>
					</Box>
				</Stack>
			)}
		</Box>
	);
}
